import { ExperienceMode, useExperienceStore } from '@/stores/experience-store';
import { FINANCE_HUB_PATH } from '@finance-hub/finance-hub-route-config';
import { flushSync } from 'react-dom';
import { SALES_PORTAL_PATH } from '@sales-portal/sales-portal-route-config';
import { useEffect } from 'react';

const experienceForPath = (pathname: string): ExperienceMode => {
  if (pathname.startsWith(SALES_PORTAL_PATH)) {
    return ExperienceMode.SALES_PORTAL;
  }
  if (pathname.startsWith(FINANCE_HUB_PATH)) {
    return ExperienceMode.FINANCE_HUB;
  }
  return ExperienceMode.OPERATOR_PORTAL;
};

// Back/forward can land on a URL the mounted stack doesn't own, and its own
// popstate listener would reset to an undefined state. Rendered ahead of the
// navigation tree so this listener runs first, and flushSync unmounts the
// stack before its listener gets a turn.
export const ExperiencePopStateSync: React.FC = () => {
  const switchToExperience = useExperienceStore(
    (state) => state.switchToExperience,
  );

  useEffect(() => {
    const onPopState = () => {
      flushSync(() => {
        switchToExperience(experienceForPath(window.location.pathname), {
          skipUrlReset: true,
        });
      });
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [switchToExperience]);

  return null;
};
